var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 80,
    viewBox: "0 0 163 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10382 46.5497C11.082 39.1288 38.8881 25.751 70.2867 31.6071C101.685 37.4632 108.5 33 142 28",
    stroke: "#FF8800",
    strokeWidth: 2.1,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1992 51.7574C33.1774 44.3365 60.9835 30.9587 92.3821 36.8148C123.781 42.6709 151.363 39.1282 161.229 36.6248",
    stroke: "#FF8800",
    strokeWidth: 2.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderLine);
export default __webpack_public_path__ + "static/media/underLine.533b7abc5964f0c20621e799d8557944.svg";
export { ForwardRef as ReactComponent };